import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { MyAuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-mobile-navigation-drawer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './mobile-navigation-drawer.component.html',
  styleUrls: ['./mobile-navigation-drawer.component.scss']
})
export class MobileNavigationDrawerComponent {
  @Input() open = false;
  @Output() closed = new EventEmitter<void>();

  private readonly router = inject(Router);
  private readonly auth = inject(MyAuthService);

  readonly isAdmin$: Observable<boolean> = this.auth.isAdmin();
  readonly isSales$: Observable<boolean> = this.auth.isSales();

  close(): void {
    this.closed.emit();
  }

  navigate(path: string[]): void {
    this.close();
    this.router.navigate(path);
  }
}
